export enum RuleOperator {
    Equal = 1,
    NotEqual = 2
}
